import * as bootstrap from "bootstrap";

// Popovers
// Note: Disable this if you're not using Bootstrap's Popovers
const popoverTriggerList = [].slice.call(document.querySelectorAll("[data-bs-toggle=\"popover\"]"))
popoverTriggerList.map((popoverTriggerEl) => {
  return new bootstrap.Popover(popoverTriggerEl)
})

// Tooltips
// Note: Disable this if you're not using Bootstrap's Tooltips
const tooltipTriggerList = [].slice.call(document.querySelectorAll("[data-bs-toggle=\"tooltip\"]"))
tooltipTriggerList.map((tooltipTriggerEl) => {
  return new bootstrap.Tooltip(tooltipTriggerEl)
})

// Bootstrap
// Note: If you want to make bootstrap globally available, e.g. for using `bootstrap.modal`
window.bootstrap = bootstrap;

// Tooltips fade out via a transition whose completion callback is queued on a
// timeout. Livewire re-renders dispose+recreate tooltips, so that callback can
// fire on an already-disposed instance (null _config/_element) and crash in
// getTipElement/_cleanTipClass. Guard the queued callback: skip it once the
// instance is disposed. This keeps the fade animation while preventing the crash.
const _tooltipQueueCallback = bootstrap.Tooltip.prototype._queueCallback;
if (typeof _tooltipQueueCallback === 'function') {
    bootstrap.Tooltip.prototype._queueCallback = function (callback, element, isAnimated) {
        return _tooltipQueueCallback.call(this, () => {
            if (this._element && this._config) {
                callback();
            }
        }, element, isAnimated);
    };
}